import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeographyMasterService } from '../geography_master.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'pin-area-master',
    templateUrl: './pincode_area_master.component.html'
})
export class PinAreaMaster implements OnInit {


    nameInput = (result: { description: string }) => result.description

    format = (result: { description: string }) => result.description

    searchByData = (text$: Observable<string>) =>
        text$
            .debounceTime(200)
            .distinctUntilChanged()
            .map(term => term.length < 2 ? []
                : this.paySlipIdResults.filter(v => v.description.indexOf(term) > -1).slice(0, 10));

    collectionDetails = [];
    searchDataPafing = [];

    indexStart = 0;
    indexEnd = 10;
    pageSize = 5;
    pageNo = 1;
    totalPage = [1];
    paySlipIdResults = [];
    SelectedArea = [];

    searchInput = '';
    IsRecordUpdated = false;
    ButtonValue = 'Save';
    viewMode = false;
    CreatedBy = '';
    IsDeleting = false;
    areaName = '';

    branchName = '';
    code = '';

    DeletedIndex = '';
    createdDate = '';
    area = [];
    areaId = '';
    PinCodeId = '';

    cityArray = [];

    dropdownSettings = {};
    selectedItems = [];
    dropdownList = [];
    branchAreaMapping = [];


    constructor(private router: Router,
        public toastr: ToastsManager, vcr: ViewContainerRef,
        private PaymentService: GeographyMasterService,
        private fb: FormBuilder) {

        this.toastr.setRootViewContainerRef(vcr);
        this.PaymentService
            .GetAreaList('')
            .subscribe(collectorObj => {
                this.paySlipIdResults = collectorObj;
            });

        this.PaymentService.GetPinCodeAreaMapping('')
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }


    ngOnInit() {
        this.PaymentService.GetPincodeList('')
            .subscribe(departmentListData => {
                for (let i = 0; i < departmentListData.length; i++) {
                    this.dropdownList.push({ "id": departmentListData[i]["id"], "itemName": departmentListData[i]["name"] });
                }
                //this.dropdownList = departmentListData;
            });

        this.dropdownSettings = {
            singleSelection: true,
            text: "Select Areas",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,          
            classes: "myclass custom-class"
        };

    }

    pagingAgent(data) {
        this.pageNo = data;
        this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
        this.indexEnd = (this.pageNo) * this.pageSize;
    }

    changeItemsPerPage(data) {
        if (this.collectionDetails.length > 0) {
            this.totalPage = [1]
            let j = 1;
            for (var i = 0; i < this.collectionDetails.length; i++) {
                i = i + this.pageSize;
                j = j + 1;
                this.totalPage.push(j);
            }
        }
        else {
            this.totalPage = [];
        }
        this.pageSize = data;
        this.indexStart = 0;
        this.indexEnd = this.pageSize;
    }

    searchInputFunction() {
        this.PaymentService.GetAreaList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    UpdateRecordsPopulate(obj) {

        this.viewMode = false;
        this.ButtonValue = 'Update';

        this.selectedItems = [];
       // this.selected(obj);
        this.areaName = obj["description"];
        //this.areaName = obj["id"];
        //for (var i = 0; i < obj["pinCode"].length; i++) {
            for (var j = 0; j < this.dropdownList.length; j++) {
                if (obj["pinCode"]["name"] == this.dropdownList[j]["itemName"]) {
                    this.selectedItems.push({ "id": this.dropdownList[j]["id"], "itemName": this.dropdownList[j]["itemName"] });
                }
            }
       // }
    }

    ViewRecordsPopulate(obj) {
        this.viewMode = true;
        this.IsRecordUpdated = true;
        this.ButtonValue = 'Save';

        this.branchName = obj["branchName"];
        this.code = obj["branchCode"];


        this.selectedItems = [];
        for (var i = 0; i < obj["area"].length; i++) {
            for (var j = 0; j < this.dropdownList.length; j++) {
                if (obj["area"][i] == this.dropdownList[j]["id"]) {
                    this.selectedItems.push({ "id": this.dropdownList[j]["id"], "itemName": this.dropdownList[j]["itemName"] });
                }
            }
        }
    }

    reset() {
        this.viewMode = false;
        this.branchName = '';
        this.code = '';
        this.ButtonValue = 'Save';
        this.PinCodeId = '';
        this.areaId = '';
        this.selectedItems = [];
    }

    memberFormSubmit() {
        if (this.PinCodeId != '') {

            let selectedAreaIds = [];
            let selectedAreaNames = [];
            for (var i = 0; i < this.selectedItems.length; i++) {
                selectedAreaIds.push(this.selectedItems[i]["id"]);
                selectedAreaNames.push(this.selectedItems[i]["itemName"]);
            }
            let data = {

                "area": selectedAreaIds,
                "areaNames": selectedAreaNames,
                "branchAreaMapping": this.branchAreaMapping,
                'branchCode': this.code,
                'branchName': this.branchName,
                "createdBy": this.createdDate,
                "createdDate": this.createdDate,
                "isDeleted": false,
                "lastModifiedBy": "",
                "lastModifiedDate": null
            }
            this.PaymentService.EditBranch(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record updated succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("Area Name and Code already exists.");
                    }
                });
        }
        else {
            let selectedAreaIds = [];
            for (var i = 0; i < this.selectedItems.length; i++) {
                selectedAreaIds.push(this.selectedItems[i]["id"]);
            }
            let data = {
                "areaId": this.areaId,
                "id": "",
                "pinCodeId": selectedAreaIds,
                "loggedInUserId": ''
            }
            this.PaymentService.CreatePinCode(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record Added succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("City Name and Code already exists.");
                    }
                });
        }
    }
    deleteProdutConfirm(id, i) {
        this.PinCodeId = id;
        this.IsDeleting = true;
        this.DeletedIndex = i;
    }
    delete() {
        let data = {
            "id": this.PinCodeId,
            "trackingState": this.DeletedIndex
        }
        // this.PaymentService.DeleteProductGroup(data)
        //     .subscribe(departmentListData => {

        //     });
    }
    deleteCancel() {
        this.IsDeleting = false;
        this.PinCodeId = '';
        this.DeletedIndex = '';
    }

    LoadGrid() {
        this.PaymentService.GetPinCodeAreaMapping(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    selected(obj) {
        this.areaId = obj["id"];
        this.areaName = obj["description"];
        this.nameInput(obj["description"]);
       // this.format(obj["description"]);
    }

    // Multiselect dropdown event start
    onItemSelect(item: any) {
    }
    OnItemDeSelect(item: any) {

    }
    onSelectAll(items: any) {

    }
    onDeSelectAll(items: any) {

    }
    //Multiselect dropdown event end
}



// WEBPACK FOOTER //
// ./src/app/system_setting/geography_master/PinCode_Area_master/pincode_area_master.component.ts